<template>
  <div class="activehelp" v-if="ti != 0">
    <div class="page1" v-if="qi == 0">
      <div class="list" v-for="(q,i) in questions[ti-1]" :key="'q'+i" @click="showQ(i)">{{q.q}}</div>
    </div>
    <div v-else>
      <div class="question">{{question}}</div>
      <div class="answer">
        <div v-for="(item,index) in answer" :key='index'><p v-html="item"></p></div>
      </div>
    </div> 
  </div>
</template>

<script>
import questions from '@/assets/js/solo/tw/questions'
export default {
  data(){
    return {
      ti: 0,
      qi: 0,
      titles: ["綁定啟用","帳號問題","駕駛須知","APP使用問題","車輛升級","用電安全"],
      questions: questions,
      question:'',//单个问题的标题
      answer:[],//单个问题的答案
    }
  },
  mounted(){
    this.ti = parseInt(this.$route.params.ti||0)
    this.qi = parseInt(this.$route.params.qi||0)
    document.title = this.titles[this.ti-1]
    if(this.ti>0&&this.qi>0&& typeof this.questions[this.ti-1][this.qi-1].a ==='string'){
      this.question=this.questions[this.ti-1][this.qi-1].q
      this.answer=this.questions[this.ti-1][this.qi-1].a.split('///')
    }
  },
  watch :{
    '$route': function(to,from){
      window.location.reload()
    }
  },
  methods: {
    showQ(i){
      this.$router.push("/sl/tw/help/"+this.ti+"/"+(i+1))
    },
  }
}
</script>

<style lang="less" scoped>
.activehelp{
  min-height: 100%;
  box-sizing: border-box;
  // background: #111117;
  padding: 32px 24px;
  color: rgba(15, 15, 16, 0.85);
  .list{
    // color: #F2F2F7;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
  }
  .question{
    color: rgba(15, 15, 16, 0.85);
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 16px;
    font-weight: 600;
  }
  .answer{
    font-size: 14px;
    line-height: 20px;
    color: rgba(15, 15, 16, 0.65);
    p{
      margin-bottom: 12px;
    }
  }
  .troublelist{
    font-size: 14px;
    color: #fff;
    line-height: 36px;
    position: relative;
  }
  .troublelist::before{
    content: "";
    width: 5px;
    height: 5px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    transform: rotate(45deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/solo/tw/helpcenter/index.vue